<template>
	<div class="ui">
		<div v-if="!channel && loading">
			<transition
			name="ui-init"
		    enter-active-class="animated fadeIn"
		    leave-active-class="animated fadeOut">
				<div class="st-login st-animate st-animate--fadeIn">
					<img src="/site/assets/images/konicaminolta__logo.svg" alt="Konica Minolta" class="konicaminolta-header__img">
					<div class="text-center">
						<div class="spinner"></div>
					</div>
				</div>
			</transition>
		</div>
		<div v-if="!channel && !loading">
			<p-loginform @login="init"></p-loginform>
		</div>
		<transition
		name="ui-header"
	    enter-active-class="animated fadeIn"
	    leave-active-class="animated fadeOut">
			<div class="ui-header" v-if="channel">
				<div class="ui-wrapper ui-wrapper--header">
					<div class="row konicaminolta-header">
						<div class="col-xs-12">
							<div class="konicaminolta-header__wrap"><img alt="Konica Minolta" class="konicaminolta-header__img" src="/site/assets/images/konicaminolta__logo.svg"></div>
						</div>
					</div>
					<div class="row user-header">
						<div class="col-xs-12 col-sm-6">
							<div class="user-header__wrap">
								<div v-if="channel">
									{{ $t("Innovative Minutes")}} | {{ channel.title }}
									<span v-if="loading">
										<div class="inline-block spinner spinner--white spinner--large"></div>
									</span>
								</div>
							</div>
						</div>
						<div class="col-xs-12 col-sm-6 text-right">
							<div class="user-header__wrap">
								<div v-if="channel.localTitle" class="inline-block">
		                            {{ channel.localTitle }}
		                        </div>
		                        <div class="user-login" v-if="channel && channel.me" :class="{'user-login--active': loginNav}">
		                            <div class="user-login__name" @click="loginNav = !loginNav">
		                                {{ channel.me.fancyname }}
		                            </div>
		                            <div class="user-login__nav">
		                            	<div v-if="channel.me && channel.me.urls && channel.me.urls.edit" class="user-login__item">
		                            		<router-link class="user-login__link" :to="{ name: 'user-edit', params: { uid : channel.me.id.toString(), role: channel.me.role.toString() }}">{{ $t('Account') }}</router-link>
		                                </div>
		                            	<div v-if="channels" v-for="ch in channels"  class="user-login__item">
		                            		<a v-if="ch.id != channel.id" :href="'/panel/?channel=' + ch.id" class="user-login__link">{{ $t('Switch to') }} {{ ch.title }}</a>
		                            	</div>
		                                <div class="user-login__item">
		                                    <a @click.prevent="logout" href="#" class="user-login__link">{{ $t('Logout') }}</a>
		                                </div>
		                            	<div class="user-login__item user-login__item--langs">
		                            		<div class="row">
		                            			<div class="col-xs-6" v-for="(messages, langcode) in $i18n.messages">
		                            				<a @click.prevent="switchto(langcode)" class="user-login__link">{{ $t(langcode) }}</a>
		                            			</div>
		                                	</div>
		                                </div>
		                            </div>
		                        </div>
		                        <div v-else>
									<a @click.prevent="logout" href="#" class="user-login__link">{{ $t('Logout') }}</a>
		                        </div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</transition>
		<div class="ui-wrapper">
			<transition
			name="ui-mainnav"
		    enter-active-class="animated fadeIn"
		    leave-active-class="animated fadeOut">
				<div class="ui-sidebar" :class="{'ui-sidebar--slim': slimnavigation }" v-if="channel">
					<v-mainnav></v-mainnav>
				</div>
			</transition>
			<transition
			name="ui-main"
		    enter-active-class="animated fadeIn"
		    leave-active-class="animated fadeOut">
				<div class="ui-main st-animate st-animate--fadeIn" :class="{'ui-main--slim': $store.getters.slimnavigation }" v-if="channel">
					<div class="notices" ref="panelnotes">
						<div v-if="notices.length > 0" class="margin-top-large margin-bottom-xlarge">
							<v-notice v-for="(data, index) in notices" :key="data.id" :data="data"></v-notice>
						</div>
					</div>
					<notifications group="main" />

					<router-view class="view"></router-view>

					<div class="st-overlay"></div>
				</div>
			</transition>
		</div>
	</div>
</template>

<script>

import axios from 'axios';
import help_rest from '@/helpers/rest';

import PLoginform from '@/pages/p-loginform';


import german from 'vee-validate/dist/locale/de';
import english from 'vee-validate/dist/locale/en';

const validateLangs = {
	de: german,
	en: english
}

export default {
	name: 'app',
	data(){
		return {
			interval: false,
			loginNav: false,
		}
	},
	components: {
		PLoginform
	},
	computed: {
		devmode(){
			return this.$store.getters.devmode;
		},
		loading(){
			return this.$store.getters.loading;
		},
		slimnavigation(){
			return this.$store.getters.slimnavigation;
		},
		channel(){
			return this.$store.getters.channel;
		},
		channels(){
			if(this.$store.getters.channels) return this.$store.getters.channels;
			if(this.$store.getters.channel.channels) return this.$store.getters.channel.channels
			return false;
		},
		notices(){
			return this.$store.getters.notices;
		}
	},
    created(){
    	this.init();
	},
	mounted(){
		document.addEventListener('mousemove', this.onMouseUpdate, false);
		document.addEventListener('mouseenter', this.onMouseUpdate, false);
	},
	destroyed(){
		document.removeEventListener('mousemove', this.onMouseUpdate);
		document.removeEventListener('mouseenter', this.onMouseUpdate);
	},
	methods: {
		...help_rest,
		init(){
			var self = this;

			this.getChannel()
			.then(this.setLocals)
			.then(this.getChannels)
			.then(channel => {
				if((self.channel && self.channel.me.role === 'superuser') || (self.channel && self.channel.name === 'linienflug')){
					this.$store.commit('SET_DEVMODE', true);
					self.$store.commit('ADD_NOTICE', {
						'text': 'Developer mode activated',
						'type': 'success'
					});
				}

				self.interval = window.setInterval(function(){
					axios.get('/api/v1/knock/knock')
					.then(function (response) {
						if(!response.data.message){
							self.$store.commit('ADD_NOTICE', {
								'text': 'The session has expired.',
								'type': 'error'
							});
							clearInterval(self.interval);
							self.$store.commit('LOGOUT');
						}
					});
				}, 30000);

				this.$store.dispatch('socket/CONNECT', window.location.hostname == 'localhost' || window.location.hostname == 'sales-tool.local')
				.catch(err => {console.error(err)});
			})
			.catch(function (error) {
				console.error(error);
			});
		},
		onMouseUpdate(e) {
			this.$store.commit('MOUSE_MOVE', e);
		},
		getChannel(){
			var self = this;
			return new Promise((resolve, reject) => {
				if(self.channel) {
					console.debug('USE Cached channel');
					resolve(self.channel);
					return self.channel;
				}

				self.restget('/api/v1/channel', 'channel')
					.then(message => {
						if(typeof message == 'object') {
							console.debug('Ajax Channel: ', message);
							self.$store.commit('SET_CHANNEL', message);

							if(message.local){
								self.$i18n.locale = message.local;
							}

							resolve(message);
							return;
						}
						resolve();
					})
					.catch(function (error) {
						self.$store.commit('ADD_ERROR', error);
						reject(error);
					});
			});
		},
		getChannels(channel){
			var self = this;
			return new Promise((resolve, reject) => {
				if(self.channels) {
					console.debug('USE Cached channels');
					resolve(self.channels);
					return self.channels;
				}

				if(channel && channel.urls && channel.urls.channels){
					axios.get(channel.urls.channels)
						.then(function (response) {
							console.debug('Ajax channels: ', channel);

							if(notices){
								notices.forEach(notice => {
									this.$store.commit('ADD_NOTICE', notice);
								});
							}
							let channels = response.data.message;
							self.$store.commit('SET_CHANNELS', channels);
							resolve(channel);
						})
						.catch(function (error) {
							self.$store.commit('ADD_ERROR', error);
							reject(error);
						});
				} else {
					resolve();
				}
			});
		},
		setLocals(channel){
			var self = this;
			return new Promise((resolve, reject) => {
				self.$i18n.locale = 'de';
		    	Object.keys(self.$i18n.messages).forEach(langcode => {
		    		if(!validateLangs[langcode]){
		    			console.error('missing langcode in validateLangs');
		    			return;
		    		}
		    		self.$validator.localize(langcode, {
			    		messages: validateLangs[langcode].messages,
			    		attributes: {
			    			'title'					: self.$i18n.messages[langcode]['Presentation name'],
			    			'firstname'				: self.$i18n.messages[langcode]['Firstname'],
			    			'email'					: self.$i18n.messages[langcode]['Email Address'],
			    			'password'				: self.$i18n.messages[langcode]['Password'],
			    			'password_confirmation'	: self.$i18n.messages[langcode]['Password Confirmation'],
			    		}
			    	});
		    	});
				resolve(channel);
			});
		},

		switchto(langcode){
    		this.$i18n.locale = langcode;
    	},

    	logout(){
    		const self = this;
    		clearInterval(self.interval);
    		this.restpatch('/api/v1/logout', {} ,'logout')
			.then(data => {
				self.$store.commit('LOGOUT');
			});
    	}
	}
}
</script>

<style lang="scss">

@import './styles/main.scss';


.user-login__item--langs {
	font-size: 10px;
	background: #e3e3e3;
	text-align: center;
}
.no-padding {
	padding: 0;
}
/*
.ui-wrapper {
	max-width: 1600px;
	margin: 0 auto;
}
.ui-wrapper--header {
	padding: 0 15px;
}
*/
.ui-main .notices {
    position: fixed;
    right: 15px;
    top: 116px;
    z-index: 50;
    min-width: 300px;
    max-width: 700px;
    width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue